/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Footer = styled.footer`
  align-items: center;
  background: ${token('color.background.input', colors.N20)};
  border-top: 1px solid ${token('color.border', colors.N40)};
  display: flex;
  justify-content: flex-end;
  min-height: ${gridSize() * 5}px;
`;
